export type PublicDeepLinkAppAreaType = 'ITEM' | 'CAMPAIGN' | 'DEFAULT_APP_AREA';

export const DEFAULT_APP_AREA = 'DEFAULT_APP_AREA';

export interface DeepLinkDto {
  url: string;
}

export type ChannelType = 'SMS' | 'PUSH' | 'EMAIL';
export type ChannelState = 'ENABLED' | 'DISABLED' | 'NOT_AVAILABLE';

export interface ChannelDto {
  type: ChannelType;
  state: ChannelState;
}
